import React from "react";
import { useTheme } from "@mui/material";

import { tss } from 'tss-react';

export default function Slide({icon, label, title, content}) {
  const theme = useTheme();
  const {classes, cx} = tss.create(theme.customComponents.slider.styles)();

  return (
    <div className={classes.sliderRoot}>
      <div className={classes.slideContainer}>
        <span className={cx(icon, classes.customIcon)}/>
        <span className={classes.slideLabel}>{label}</span>
        <span className={classes.slideTitle}>{title}</span>
        <p className={classes.slideContent}>{content}</p>
      </div>
    </div>
  )
}
